import { useEffect, useState } from "react";
import { FocusOn } from "react-focus-on";
import ReactPortal from "./components/ReactPortal";
import ModalWithSlider from "./components/ModalWithSlider";
import ModalWithTitleAndClose from "./components/ModalWithTitleAndClose";
import {
    ModalProps,
    ModalTypes,
    ModalWithSliderProps,
    ModalWithTitleAndCloseProps,
} from "./interface";
import styles from "./modal.module.scss";

const Modal = ({
    children,
    isOpen,
    handleClose = () => null,
    wrapperId = "react-portal-modal-container",
    type,
    enableFocusTrap = true,
    enableScrollLock = true,
    propsForModalType,
}: ModalProps) => {
    const [scrollRestore, setScrollRestore] = useState<number>(0);

    useEffect(() => {
        if (isOpen) {
            setScrollRestore(window.scrollY);
        } else if (scrollRestore !== 0) {
            setTimeout(() => {
                window.scrollTo(0, scrollRestore);
            }, 0);
        }
    }, [isOpen, scrollRestore]);

    if (!isOpen) return null;

    let child: React.ReactNode;

    switch (type) {
        case ModalTypes.MODAL_WITH_TITLE_AND_CLOSE:
            child = (
                <ModalWithTitleAndClose
                    handleClose={handleClose}
                    {...(propsForModalType as ModalWithTitleAndCloseProps)}
                >
                    {children}
                </ModalWithTitleAndClose>
            );
            break;

        case ModalTypes.MODAL_WITH_SLIDER:
            child = (
                <ModalWithSlider
                    handleClose={handleClose}
                    {...(propsForModalType as ModalWithSliderProps)}
                >
                    {children}
                </ModalWithSlider>
            );
            break;

        default:
            return null;
    }

    return (
        <ReactPortal wrapperId={wrapperId}>
            <FocusOn
                onEscapeKey={handleClose}
                enabled={enableFocusTrap}
                scrollLock={enableScrollLock}
            >
                <div
                    className={styles.modal}
                    data-testid={wrapperId}
                    role="dialog"
                >
                    {child}
                </div>
            </FocusOn>
        </ReactPortal>
    );
};
export default Modal;
